import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const STATIC_VEHICLE_DATA = gql`
  query getStaticVehicleById($vehicleStoreId: String!) {
    getStaticVehicleById(vehicleStoreId: $vehicleStoreId) {
      rapid_name
    }
  }
`;
